import { Box, Stack } from '@mui/material';
import { ProductData } from 'utils/types';
import { babaUtils } from '../utils';
import { BabaSubProduct } from './sub';
import { StyledSubProductsContainer } from './style';

export const SubProductsContainer: React.FC<{
  subProductsSplit: ProductData[][];
  subItemsGridRef: any;
}> = ({ subProductsSplit, subItemsGridRef }) => (
  <StyledSubProductsContainer
    ref={subItemsGridRef}
    className="sub-items-container-grid"
  >
    {subProductsSplit &&
      subProductsSplit.length > 0 &&
      subProductsSplit.map((subProducts, i) => (
        <Stack justifyContent="center" alignItems="center" key={i}>
          <Box className="sub-items-grid" rowGap="8px">
            {subProducts.map((product, i, sbArray) => (
              <Stack justifyContent="center" alignItems="center" key={i}>
                <BabaSubProduct
                  key={i}
                  textFontColorHex={product.textFontColorHex}
                  quantityDisplay={product.quantityDisplay}
                  images={product.images}
                  isLastInRow={babaUtils.getIsLastInRow(i, sbArray)}
                />
              </Stack>
            ))}
          </Box>
        </Stack>
      ))}
  </StyledSubProductsContainer>
);
